export default {
	// SOLUTIONS
  'safety_and_ergonomics': {
    heading: 'Superior safety and ergonomics driven by nurse and patient-centric design',
    description: 'Ergonomic and safety solutions are protecting back of nurses, reducing nurses’ sick leave related to MSD’s and minimizing outcomes of patient falls, HAPIs & other adverse events',
    images: [ 'essenza300/superior-safety-and-ergonomics.jpg' ]
  },
  'single_platform': {
    heading: 'Efficiency of a single platform unlocking incredible versatility',
    description: 'Don’t settle for a compromise between efficiency and versatility, with Essenza you can have both.',
    images: [ 'essenza300/efficiency-of-a-single-platform.jpg' ]
  },
  'advanced_technologies': {
    heading: 'Unparalleled effectiveness brought by advanced technologies',
    description: 'Advanced technologies save time through decreased number of unnecessary operationbs and simplief caregivers’ procedures.',
    images: [ 'essenza300/unparalleled-effectiveness.jpg' ]
  },

	// KEY FEATURES
  'transportation': {
    heading: 'Transportation',
    subExplanations: [
      'easydrive',
      '5th_castor',
      'softbrake'
    ]
  },
  'mobilization': {
    heading: 'Safety',
    subExplanations: [
      'mobilift',
      'mobigrips',
      'mobipad'
    ]
  },
  'additional_controls': {
    heading: 'Additional controls',
    subExplanations: [
      'foot_controls',
      'integrated-mattress-controls'
    ]
  },
  'comfort': {
    heading: 'Comfort',
    subExplanations: [
      'ergoframe'
    ]
  },

  // SUB-EXPLANATIONS
  'easydrive': {
    heading: 'EasyDrive',
    description: 'Battery powered wheel in the middle of the bed allows easy manipulation and transportation of the patient.',
    images: [
      'essenza300/easydrive.jpg'
    ],
    camera: {
      orbit: '66.63deg 69.28deg 180m',
      target: '99m 118m -13m',
      fov: '12.5deg'
    }
  },
  '5th_castor': {
    heading: '5th Castor',
    description: 'The 5th castor makes transporting the bed through long corridors easier, maintaining a straight line.',
    images: [
      'essenza300/5th-castor.jpg'
    ],
    camera: {
      orbit: '116.7deg 66.05deg 180m',
      target: '-6.8m 15.1m 0.5m',
      fov: '12.8deg'
    }
  },
  'softbrake': {
    heading: 'SoftBrake',
    description: 'A unique design of a castor that provides excellence in the operation of the brake levers, with low physical strain needed to prevent caregivers from musculoskeletal injuries.',
    images: [
      'essenza300/softbrake.jpg'
    ],
    camera: {
      orbit: '133.5deg 70.92deg 180m',
      target: '80m 21m -40m',
      fov: '15deg'
    }
  },
  'mobilift': {
    heading: 'Mobi-lift',
    description: 'Mobi-Lift handle provides support during bed exit.',
    images: [
      'essenza300/mobilift.jpg'
    ],
    animation: [
      'folding_of_foot_siderails',
      'mobilift',
      'mobilift_r'
    ],
    camera: {
      orbit: '61deg 75deg 180m',
      target: '82m 96m 42m',
      fov: '17deg'
    }
  },
  'mobigrips': {
    heading: 'Mobigrips',
    description: 'Mobi-Grips provide support for self-mobilization.',
    images: [
      'essenza300/mobigrips.jpg'
    ],
    animation: [
      'folding_of_foot_siderails'
    ],
    camera: {
      orbit: '40deg 68.09deg 180m',
      target: '-20m 120m 35m',
      fov: '14.5deg'
    }
  },
  'mobipad': {
    heading: 'Mobi-Pad',
    description: 'Mobi-Pad adjusts the height of the bed.',
    images: [
      'essenza300/mobipad.jpg'
    ],
    animation: [
      'folding_of_foot_siderails'
    ],
    camera: {
      orbit: '40deg 68.09deg 180m',
      target: '-20m 120m 35m',
      fov: '14.5deg'
    }
  },
  'ergoframe': {
    heading: 'Ergoframe',
    description: 'Ergoframe makes patient positioning more comfortable. Bed with ergoframe reduces peak pressure in the pelvic area by 16%.',
    images: [
      'essenza300/ergoframe.jpg'
    ],
    camera: {
      orbit: 'initial',
      target: 'initial'
    }
  },
  'foot_controls': {
    heading: 'Foot controls',
    description: 'Thanks to foot controls caregiver can handle the patient and operate the bed ergonomically.',
    images: [
      'essenza300/foot-controls.jpg'
    ],
    camera: {
      orbit: '53deg 73deg 180m',
      target: '35m 19m 32m',
      fov: '17deg'
    }
  },
  'integrated-mattress-controls': {
    heading: 'Integrated mattress controls',
    description: 'Integrated Air2Care mattress increases patient comfort & ease of caregiver use while minimizing the physical strain.',
    images: [
      'essenza300/integrated-mattress-controls.jpg'
    ],
    camera: {
      orbit: '141.3deg 60.34deg 180m',
      target: '42m 111m -49m',
      fov: '12.9deg'
    }
  }
}
